import { gql } from 'graphql-request';
import { graphQLApi } from 'utils/Api';
import { QueryGetFlexibleBenefitResponse } from '../types';

const getFlexibleBenefitQuery = gql`
  query getFlexibleBenefitComponent($id: String!, $isFbpDecimalEnabled: Boolean) {
    payrollGetFlexibleBenefitsComponent(id: $id, isFbpDecimalEnabled: $isFbpDecimalEnabled) {
      component {
        id
        name
        description
        category
        is_active
        settings {
          salary_settings {
            show_in_gross_salary
            non_cash_benefit
          }
          benefit_amount_settings {
            unit
            list_of_options_amount {
              amounts
              default_option_index
              allow_multiple
              amount_labels
            }
            fixed_amount {
              amount
              description
            }
            range_amount {
              max
              min
              step
            }
          }
          tax_behaviour {
            tax_exempt_in_old_regime
            tax_exempt_in_new_regime
            tax_exemption_section
            tax_deduction_behaviour
          }
          display_behaviour {
            show_zero
            visible_to_employee
            display_name
          }
          declaration_settings {
            declaration_enabled
          }
          hold_settings {
            hold_unclaimed_amount
          }
          arrear_behaviour {
            consider_in_arrear
            allow_negative
          }
          proration_behaviour {
            support_proration
          }
          pf_behaviour {
            include_in_pf_wages
          }
          esi_behaviour {
            include_in_esi_wages
          }
          pt_behaviour {
            include_in_pt_wages
          }
          lwf_behaviour {
            include_in_lwf_wages
          }
          gratuity_behaviour {
            include_in_gratuity_wages
          }
          leave_encashment_behaviour {
            include_in_leave_encashment_wages
          }
          base_compensation_behaviour {
            include_in_base_compensation
          }
        }
        component_type
        component_space
        tenant_id
        created_at
        updated_at
        response_precision
      }
    }
  }
`;

export const getFlexibleBenefit = (id: string, isFbpDecimalEnabled?: boolean) => {
  return graphQLApi<QueryGetFlexibleBenefitResponse, { id: string; isFbpDecimalEnabled?: boolean }>({
    query: getFlexibleBenefitQuery,
    queryVariables: { id, isFbpDecimalEnabled },
  });
};
